import { useCallback } from 'react';
import { useMutation } from 'react-query';

import referralRequest, {
  ReferralVariables,
  Response,
} from 'data/requests/referral';
import { CDError } from 'utils/error';

const useReferral = () => {
  const { mutateAsync: referralMut, isLoading: referralLoading } = useMutation<
    Response,
    CDError,
    ReferralVariables
  >(referralRequest);

  const referral = useCallback(
    async ({
      name,
      restaurantName,
      city,
      phoneNumber,
      email,
    }: ReferralVariables) => {
      const response = await referralMut({
        name,
        restaurantName,
        city,
        phoneNumber,
        email,
      });
      return response;
    },
    [referralMut],
  );

  return {
    referral,
    referralLoading,
  };
};

export default useReferral;
